import { useEffect, useRef, useState } from "react";
import plusIcon from "../../assets/images/plus.png";
import minusIcon from "../../assets/images/minus.png";
import "./accordian.css";

const defaultProps = {
  id: 'id',
  animate: false,
  defaultOpen: true,
  useMasterToggle: true,
  onSectionToggle: (title, expanded) => {},
  sections: [
    {
      title: "",
      content: <div></div>,
      defaultOpen: false,
    },
  ],
};

export default function Accordian(props = defaultProps) {
  const [expanded, setExpanded] = useState(props.defaultOpen ?? false);

  useEffect(() => {}, []);

  /**
   * Dynamically render the accordian items
   * @returns
   */
  function RenderItems() {
    return props.sections.map((item, index) => <AccordianItem key={`accoridan-${props.id}-item-${index}`} {...item} animate={props.animate} onSectionToggle={props.onSectionToggle} />);
  }

  return (
    <section className="accordian-container">
      {/* top controls */}
      {props.useMasterToggle && (
        <div className="top-controls">
          <label>Toggle All Sections</label>
          <button className="standard-button accordian-button">
            <img src={expanded ? minusIcon : plusIcon} alt="toggle expand all button" />
          </button>
        </div>
      )}

      {/* Accordian Tabs */}
      {RenderItems()}
    </section>
  );
}

const defaultAccordianItemProps = {
  animate: false,
  title: "",
  content: <div></div>,
  defaultOpen: false,
  onSectionToggle: (title, expanded) => {},
};
export function AccordianItem(props = defaultAccordianItemProps) {
  const [expanded, setExpanded] = useState(props.defaultOpen ?? false);
  const outerRef = useRef(null);
  const contentRef = useRef(null);

  //consts
  const classes = useRef(["accordian-item"]);

  useEffect(() => {
    // if (props.animate === true) classes.current.push("animate");
    // if (expanded === true) classes.current.push("expanded");

    const focusableElements = contentRef.current.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");

    focusableElements.forEach((el) => {
      el.tabIndex = expanded ? 0 : -1;
    });

    let maxHeight = contentRef.current.getBoundingClientRect().height + 100;

    if (expanded) outerRef.current.style.maxHeight = maxHeight + "px";
    else outerRef.current.style.maxHeight = "65px";
  }, [expanded]);

  return (
    <div ref={outerRef} className={["accordian-item", expanded ? "expanded" : "", props.animate ? "animate" : ""].join(" ")}>
      {/* accordian item controls */}
      <div className="accordian-item-top">
        <h3 className="accordian-title">{props.title}</h3>
        {/* Toggle Button */}
        <button
          key={'accordian-toggle-button'}
          className="standard-button accordian-button"
          onClick={() => {
            //call callback for on open
            if (props.onSectionToggle) props.onSectionToggle(props.title, !expanded);
            setExpanded(!expanded);
          }}
        >
          <img src={expanded ? minusIcon : plusIcon} alt={`toggle expand ${props.title} button`} />
        </button>
      </div>
      {/* Dynamic Content */}
      <div className="accordian-item-content-container" ref={contentRef}>
        {props.content}
      </div>
    </div>
  );
}
